import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';
import { SheetsDisplayGridRowDataFragmentGql } from './SheetsDisplayGridRowFragmentGql';

export const FlowDownstreamSheetsFilteredByFlowOutputFieldQueryGql: DocumentNode = gql`
query FlowDownstreamSheetsFilteredByFlowOutputFieldQuery(
  $flowVizportalUrlId: String!,
  $selectedFlowOutputFieldId: ID!,
  $first: Int!,
  $offset: Int!,
  $orderBy: SheetSortOrder!
) {
  flows(filter: { vizportalUrlId: $flowVizportalUrlId }) {
    outputFieldsConnection(filter: { id: $selectedFlowOutputFieldId }) {
      nodes {
        downstreamSheetsConnection(first: $first, offset: $offset, orderBy: $orderBy) {
          totalCount
          nodes {
            ...SheetsDisplayGridRowDataFragment
          }
        }
      }
    }
  }
}
${SheetsDisplayGridRowDataFragmentGql}
`;
